// this is for a certain condition where user selects inward xflow and 
// is sole proprietor or freelancer

export const getXflowProduct = ({
    orgDetails
}) => {
    if(orgDetails &&
       (orgDetails?.inwardXflow) &&
       !orgDetails?.inwardIDFC &&
       !orgDetails?.outwardIDFC &&
       !orgDetails?.inwardYes &&
       !orgDetails?.outwardYes &&
       !orgDetails?.inwardPayglocal &&
       !orgDetails?.inwardRBL &&
       !orgDetails?.inwardDBS &&
       (orgDetails?.companyType === "SOLE_PRORIETOR" || orgDetails?.companyType === "FREELANCER")
    ) return true;

    return false;
}

